import { RouterProvider } from 'react-router-dom';
import './scss/index.scss';

import { createRoot } from 'react-dom/client';
import appRouter from './router/appRouter';

// Get the root DOM element where React will mount
const container = document.getElementById('root');

if (!container) {
  throw new Error('Root container missing in HTML');
}

// Create a React root using the new React 18 API
const root = createRoot(container);

// Render the React app inside the root
root.render(<RouterProvider router={appRouter} />);
